import { createContext, useContext, useState } from 'react';

const PermissionContext = createContext({
  permissions: [],
  role: null,
  loading: false,
  error: null,
  refreshPermissions: async () => {},
});

// eslint-disable-next-line react-refresh/only-export-components
export const usePermissionContext = () => useContext(PermissionContext);

export function PermissionProvider({
  children,
  permissions = [],
  role = null,
}) {
  const [loading] = useState(false);
  const [error] = useState(null);

  const refreshPermissions = async () => {
    // Refresh is now handled by the parent layout (e.g., DashboardLayout)
  };

  return (
    <PermissionContext.Provider
      value={{ permissions, role, refreshPermissions, loading, error }}
    >
      {children}
    </PermissionContext.Provider>
  );
}
